export default{
    workspace: state => {
        return state.workspace
    },
    getCustomFields: (state) => (workspaceId) =>{
        return state.customFields.find(workspace => workspace.workspaceIds.includes(workspaceId))
    }
}